<!--
 * @Author: zhengxiaoxiao
 * @Date: 2020-06-10 15:01:15
 * @Description: Do not edit
--> 
<template>
  <div class="service-banner" :style="{background: `url(${bannerContent.src})`,backgroundSize: 'cover',backgroundPosition: 'center'}">
    <div class="title-warp">
      <ElRow class="title-content">
        <ElCol class="text" :xs="{span:20,push:2}" :sm="{span:22,push:1}" :md="{span:12,push:12}" :lg="{span:12,push:13}" :xl="{span:12,push:14}">
          <p class="title">{{bannerContent.title}}</p>
          <p class="content" v-html="bannerContent.content"></p>
        </ElCol>
      </ElRow>
    </div>
  </div>
</template>

<script>
export default {
  name: "banner",
  props: {
    bannerContent: {
      type: Object,
      default: () => {
        return {}
      }
    },
  }
}
</script>

<style lang='less' scoped>
@import "../../../style/constant";

.service-banner {
  height: 480px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .title-warp {
    /*padding: 60px 0;*/
    align-items: center;
    width: @page-width;

    .title-content {
      .text {
        // background-color: hsla(0,0%,100%,.51);
        // padding: 30px;
      }
      vertical-align: middle;
      // color: #ffffff;
      font-weight: 300;

      .title {
        font-weight: 500;
        font-size: 32px;
        line-height: 1.2em;
        margin-bottom: 30px;
      }

      .content {
        font-size: 21px;
        line-height: 1.6em;
      }
    }
  }
}

@media screen and (max-width: 996px) {
  .service-banner {
    height: 40vh;
    background: #435ba1 !important;

    .title-content {
      color: #ffffff;
      .title {
        font-size: 32px !important;
      }

      .content {
        font-size: 20px !important;
      }
    }
  }
}
</style>